<template>
    <div class="audit">
        <div class="title">
            <h1>信息审核<span> / Information audit</span></h1>
        </div>
        
        <div class="box" v-if="!orderId">
            <img src="../../assets/images/public/icon_time.png">
            <h2>信息正在审核中</h2>
            <p style="color:red;">您的报名信息正在审核中，考试中心将会在5个工作日内告知您审核结果。请注意手机短信或邮件通知。收到审核结果通知后，请在首页-个人中心-我的报名中查询结果，审核通过后请缴费。</p>
            <router-link to="/"><el-button>返回首页</el-button></router-link>
        </div>

        <div class="box" v-else>
            <img src="../../assets/images/public/icon_success.png">
            <h2>恭喜，审核通过</h2>
            <p>初步审核合格.CERM考试中心将保留对您报名资料的真实性和<br>有效性进行进一步核验的权利。</p>
            <el-button @click="dialogVisible = true">去支付</el-button>
        </div>

        <el-dialog
            title="请填写报名码"
            :visible.sync="dialogVisible"
            width="400px">
            <el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="0" @submit.native.prevent>
                <el-form-item prop="enrollCode">
                    <el-input v-model="enrollInfo.enrollCode" placeholder="请输入报名码"></el-input>
                </el-form-item>
            </el-form>
            <div class="tip">请联系报名机构索取报名码或打010-85521991转801电话咨询</div>
            <span slot="footer" class="dialog-footer">
                <el-button :loading="submitLoading" @click="next">去支付</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import { enrollcodeCodeUsed } from '@/api/enroll'
export default {
    name: 'audit',
    components: {
        
    },
    data(){
        return {
            state: 1,
            dialogVisible: false,
            submitLoading: false,
            enrollInfo: {
                enrollCode: '',
            },
            enrollRules: {
                enrollCode: [
                    { required: true, message: '请输入报名码', trigger: 'blur' }
                ],
            },
            orderId: ''
        }
    },
    mounted(){
        this.$emit('changeIndex',5)
        this.orderId = this.$route.params.id
    },
    methods:{
        next(){
            this.$refs['enrollInfo'].validate((valid) => {
                if (valid) {
                    this.submitLoading = true

                    enrollcodeCodeUsed({ enrollCode: this.enrollInfo.enrollCode, enrollId: this.orderId }).then(res => {
                        if(res.orderId){
                            this.$router.push(`/enroll/pay/${res.orderId}`)
                        }else{
                            this.$message.error('验证失败，请重试')
                        }
                        this.submitLoading = false
                    }).catch(() => {
                        this.submitLoading = false
                    })
                }
            }) 
        }
    }
}
</script>

<style scoped>
    .box{text-align: center;padding: 120px;}
    .box img{display: block;margin: auto;}
    .box h2{font-size: 18px;color: #000000;font-weight: 600;line-height: 58px;}
    .box p{font-size: 14px;color: #999999;line-height: 18px;margin-bottom: 32px;}
    .tip{font-size: 12px;color: #999999;line-height: 18px;}

    .audit >>> .el-input{width: 100% !important;}
    .audit >>> .el-dialog__body{padding: 10px 20px;}
    .audit >>> .el-dialog__footer{text-align: center;}
    
</style>
